<template>
	<v-text-field v-if="inputMask"
				  v-mask="inputMask"
				  v-bind="$attrs"
				  v-on="$listeners">
		<slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
	</v-text-field>
	<v-text-field v-else
				  v-bind="$attrs"
				  v-on="$listeners">
		<slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
	</v-text-field>
</template>
<script>
	export default {
		name: 'MaskedTextFieldWrapper',
		props: {
			inputMask: {
				type: String,
				default: null,
			},
		},
	};
</script>
